import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddTrustTemplateDialogComponent } from '../../add-trust-template-dialog/add-trust-template-dialog.component';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'manage-template-type',
  templateUrl: './manage-template-type.component.html',
  styleUrl: './manage-template-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageTemplateTypeComponent implements OnInit {
  disableSearch: boolean = false;
  textBoxPlaceHolder: string = '';
  filterText: string = '';
  isConnectWithMXDisable = true;
  isAddManuallyDisable = true;
  selectedItemList: any;

  origin;
  data = [];
  connectionUserFormControl = new UntypedFormControl();

  title = 'Manage Financial Accounts ';

  constructor(
    @Inject(MAT_DIALOG_DATA) public titleListData: any,
    private cd: ChangeDetectorRef,
    public dialogRef: MatDialogRef<AddTrustTemplateDialogComponent>
  ) {}

  ngOnInit(): void {
    this.title = `Manage ${this.titleListData.title}`;
    this.textBoxPlaceHolder = `Search ${this.titleListData.title}`;
    // this.selectedItemList.dialogClose = '';

    this.origin = this.titleListData.origin;
    this.data = this.titleListData.groupList.map((x) => {
      return {
        ...x,
        isSelected: false,
      };
    });
    this.data.forEach((opt) => {
      opt.isSelected = false;
    });
  }

  onSearchValue(value) {
    this.connectionUserFormControl.setValue(value);
    this.filterText = value;
    this.cd.detectChanges();
  }

  onClearInput() {
    this.connectionUserFormControl.setValue('');
    this.cd.detectChanges();
  }

  onTempalteClick(item) {
    this.data.forEach((opt) => {
      opt.isSelected = false;
    });
    item.isSelected = true;
    this.selectedItemList = item;
    this.isAddManuallyDisable = false;
    this.isConnectWithMXDisable = false;
  }

  connectWithMX() {
    this.dialogRef.close(this.selectedItemList);
  }

  addManually() {
    this.dialogRef.close(this.selectedItemList);
  }

  closeDialog() {
    this.data.forEach((opt) => {
      opt.isSelected = false;
    });
    this.selectedItemList = null;
    this.dialogRef.close(null);
  }
}
